<template>
  <div
    role="tablist"
    class="collapse-icon"
  >
    <b-card
      no-body
      :class="
        `collapseCard border-default ${cardClass || 'border-t'} ${
          visible ? 'open' : ''
        }`
      "
    >
      <b-card-header
        :class="{ collapsed: !visible }"
        :aria-expanded="visible ? 'true' : 'false'"
        :aria-controls="collapseItemID"
        data-toggle="collapse"
        :header-class="`px-2 ${headerClass}`"
        @click.self="updateVisible(!visible)"
      >
        <slot name="header">
          <div class="d-flex align-items-center">
            <span class="lead text-sm text-thicker">{{ title }} </span>
            <GjIcon
              v-if="hasErrors !== ''"
              v-b-tooltip.hover
              title="Action needed."
              name="InfoAlt"
              class="text-danger ml-1"
              size="20"
            />
          </div>
        </slot>
      </b-card-header>

      <b-collapse
        :id="collapseItemID"
        v-model="visible"
        accordion
        role="tab-panel"
      >
        <b-card-body
          class="px-2"
          :class="containerClass"
        >
          <slot :visible="visible" />
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BCollapse,
} from 'bootstrap-vue'

import { v4 as uuidv4 } from 'uuid'

export default {
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BCollapse,
  },
  props: {
    headerClass: {
      type: String,
      default: '',
    },
    cardClass: {
      type: String,
      default: '',
    },
    isVisible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    containerClass: {
      type: String,
      default: '',
    },
    hasErrors: {
      type: String,
      default: '',
    },
    toggleVisibility: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      visible: false,
      collapseItemID: '',
    }
  },
  watch: {
    visible(val) {
      this.$emit('visibility', val)
    },
    toggleVisibility(val) {
      this.visible = val
    },
  },
  created() {
    this.collapseItemID = uuidv4()
    this.visible = this.isVisible
  },
  methods: {
    updateVisible(val = true) {
      this.visible = val
      this.$emit('visible', val)
    },
  },
}
</script>
<style lang="scss" scoped>
.collapseCard {
  border-radius: 0;
}
</style>
